<template>
    <section class="chart-container">
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="项目">
					<el-select v-model="filters.projectId" multiple  collapse-tags   @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn" style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn" style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="功能区" >
					<el-select v-model="filters.functionalArea"  multiple collapse-tags  style="width:320px" filterable reserve-keyword>
						<el-option
							v-for="item in functionalAreaList"
							:label="item.name"
							:value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="数据类型" >
					<el-select v-model="dataType" placeholder="请选择数据类型"  style="max-width:100px" >
						<el-option label="小时" value="hour"></el-option>
						<el-option label="天" value="day"></el-option>
					</el-select>
				</el-form-item>
             
             	<el-form-item label="时间">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="dataType=='hour'?pickerOptionsHour:pickerOptionsMonth" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" style="max-width:340px" align="right" :default-time="['06:00:00', '05:00:00']">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow></my-button>
				</el-form-item>
                <el-form-item v-if="dataType=='day'">
                    <el-radio v-model="dayDataType" label="day" @input="getDataList">昼</el-radio>
                    <el-radio v-model="dayDataType" label="night" @input="getDataList">夜</el-radio>
				</el-form-item>

                <el-form-item label="显示联动">
                    <el-switch v-model="linkage" @change="changeLinkage"></el-switch>
                </el-form-item>
			</el-form>
		</el-col>

        <!-- 折线图 -->
        <el-col :span="24"   v-loading="listLoading">
            <div id="chartLine" ></div>
        </el-col>

        
		<el-dialog  title="详情" :visible.sync="deviceDataVisible" :close-on-click-modal="true" >

            <el-tag    effect="plain">    功能区名称：{{ choosefunName }} </el-tag>
            <el-tag    effect="plain" style="margin-left: 20px;">    时间：{{ chooseTime }} </el-tag>
            <el-tag    effect="plain" style="margin-left: 20px;">    数值：{{ chooseValue }} </el-tag>

            <el-descriptions title="异常报警"  :column="3" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="stateInfo.length>0">
                <template v-for="item in stateInfo">
                    <el-descriptions-item  label="点位名称">{{ deviceMap.get(item.mn) }} </el-descriptions-item>
                    <el-descriptions-item  label="时间"> {{item.time}}  </el-descriptions-item>
                    <el-descriptions-item  label="事件"> {{item.remark}} </el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="声源定位"  :column="3" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="noiseVideo.length>0">
                <template v-for="item in noiseVideo">
                    <el-descriptions-item  label="点位名称"> {{ deviceMap.get(item.nodenum) }}</el-descriptions-item>
                    <el-descriptions-item  label="时间"> {{item.alarmdate}}  </el-descriptions-item>
                    <el-descriptions-item  label="操作"> 
					    <el-button size="small" @click="showIdent(item)">查看视频</el-button>
                    </el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="噪声录音"  :column="3" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="recording.length>0">
                <template v-for="item in recording">
                    <el-descriptions-item  label="点位名称">{{ deviceMap.get(item.mn) }} </el-descriptions-item>
                    <el-descriptions-item  label="时间"> {{item.startTime}}  </el-descriptions-item>
                    <el-descriptions-item  label="操作"> 
                        <audio :src="item.src" controls="controls"></audio>
                    </el-descriptions-item>
                </template>
            </el-descriptions>
        </el-dialog>

        <el-dialog title="视频详情" :visible.sync="soundVisible" top="8vh" >
			<video :src="mp4Src" controls="controls" style="width: 100%;"></video>
		</el-dialog>

    </section>
</template>

<script>
    import * as echarts from "echarts";
    import {getProjects,getDevicesByProjectId,getFunctionalAreaList,getTimeDistributionChartData,getTimeDistributionChartDataContent} from '../../api/api';
    import {formatDate,in_array,setDeviceEvent} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

    export default {
        props: {
            collapsed: {
                type: Boolean,
            },
        },
        components: { myButton },
        data() {
            return {
                pickerOptionsHour: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                pickerOptionsMonth:{
                    shortcuts: [{
                        text: '最近一季度',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 183);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                filters: {
                    mn: '',
                    projectId:'',
                    time:[],
                    functionalArea:''
                },
                chartLine: null,
                projects:[],
                devices:[],
                deviceMap:new Map(),
                chooseNames:[],
                realDatas:[],
                listLoading:false,
                firstFlag:true,
                formHeight:0,
                dataType:'hour',
                type:1,
                functionalAreaList:[],
                functionalAreaMap:new Map(),
                dayDataType:"day",
                chooseParas:{},
                linkage:false,
                noiseVideo:[],
                recording:[],
                stateInfo:[],
                deviceDataVisible:false,
                mp4Src:"",
                soundVisible:false,
                choosefunName:"",
                chooseTime:"",
                chooseValue:''
            }
        },
        watch: {
            'collapsed': {
                handler (val) {
                    if(this.chartLine!=null){
                        this.chartLine.resize();
                    }
                },
                deep: true
            },
        },
        methods: {
            showIdent(row){
				this.mp4Src=window.configuration.resourceUrlJava+"video/"+row.videopaths;
				this.soundVisible=true;
			},
            changeLinkage(){
                this.getDataList();
            },
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}
			},
            drawLineChart:function(aData,seriesData) {
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                    title: {
                        text: '时间分布图',
                        x:'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    legend: {
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                        top:30
                    },
                    toolbox: {
                        show : true,
                        feature: {
                            dataZoom: {
                                yAxisIndex:"none"
                            },
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {
                                show:true,
                                excludeComponents :['toolbox'],
                                pixelRatio: 2
                            }
                        }
                    },
                    grid: {
                        top: 60,
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
                        name:'时间',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'数值',
                        scale:true
                    },
                    series:seriesData
                },true);

                var _this=this;
                if(this.linkage){
                    this.chartLine.off('click');
                    this.chartLine.on('click', function (param) {
                        if(param.data.name!=undefined){
                            _this.getEventDetail(param.data.name,param.data.xAxis);

                            _this.choosefunName=param.data.name;
                            _this.chooseTime=param.data.xAxis;
                            _this.chooseValue=param.data.yAxis;
                        }
                    });
                }
              
            },
            getEventDetail(funName,date){
                let para = this.chooseParas;
                para.funName=funName;
                para.date=date;
                this.deviceDataVisible=true;
                this.listLoading = true;
                
                //数据格式处理
				getTimeDistributionChartDataContent(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result==true||res.data.result=="true"){
                        var realDatas = res.data.datas;
                        this.noiseVideo=realDatas.noiseVideo;
                        this.recording=realDatas.recording;
                        this.stateInfo=realDatas.stateInfo;

                        //处理异常报警
						if(this.stateInfo.length>0){
							for (let index = 0; index < this.stateInfo.length; index++) {
								const data = this.stateInfo[index];
								data.remark=setDeviceEvent(data);
							}
						}
                        if(this.recording.length>0){
                            this.recording.forEach(element => {
                                element.src=window.configuration.resourceUrlJava+"recording/"+element.mn+"/"+element.fileFolderName+"/"+element.filename;
                            });
                        }
                    }else{
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }
				});
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
			        if(this.projects.length>0){
                        this.filters.projectId=[];
                        this.filters.projectId.push(this.projects[0].projectId);
						this.getDevices();
                        this.getDataList();
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
                    endtime=formatDate(this.filters.time[1]);

                    if(this.dataType=="hour"){
						var day=90;
                        //如果开始时间超过三个月
                        var d1 = new Date(this.filters.time[0]);
                        var d2 = new Date(this.filters.time[1]);
                        var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
                        if(days>day){
                            this.$message({
                                message: "选择时间范围超过"+day+"天",
                                type: 'warn'
                            })
                            return;
                        }
					}
                }
                let para = {
                    projectIds: this.filters.projectId.toString(),
                    functionalAreas: this.filters.functionalArea.toString(),
                    mns: this.filters.mn.toString(),
                    dataType:this.dataType,
                    startDate: starttime,
                    endDate: endtime,
                    linkage:this.linkage
                };
                this.listLoading = true;
                
                //数据格式处理
				getTimeDistributionChartData(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result==true||res.data.result=="true"){
                        this.realDatas = res.data.datas;
                        var seriesData=[];
                        var aData=this.realDatas.timeList;
                        var chartData;
                        if(this.dataType=="hour"){
                            chartData=this.realDatas.chartData;
                        }else if(this.dayDataType=="day"){
                            chartData=this.realDatas.dayChartData;
                        }else{
                            chartData=this.realDatas.nightChartData;
                        }
                        
                        if(chartData.length<=0){
                            this.$message({
                                message: "查询时间内暂无数据",
                                type: 'warning'
                            })
                        }else{
                            this.chooseParas=para;

                            chartData.forEach((item)=>{
                                let deviceOne={};
                                deviceOne.type='line';
                                deviceOne.name=item.name;
                                deviceOne.connectNulls=false;//null中断
                                deviceOne.data=item.data;

                                //判断有没有事件
                                if(this.linkage){
                                    var data=[];
                                    for (let index = 0; index < item.data.length; index++) {
                                        const element = item.data[index];
                                        //1、先判断异常事件  stateInfo  红色
                                        if(item.stateInfo.length!=0&&item.stateInfo[index]!="-"){
                                            data.push({
                                                name: item.name, value: '事件', xAxis: aData[index], yAxis: element,itemStyle: { color:'#FF0033' }
                                            })
                                        }else if(item.noiseVideo.length!=0&&item.noiseVideo[index]!="-"){
                                            data.push({
                                                name: item.name, value: '定位', xAxis: aData[index], yAxis: element,itemStyle: { color:'#FF9900' }
                                            })
                                        }else if(item.recording.length!=0&&item.recording[index]!="-"){
                                            data.push({
                                                name: item.name, value: '录音', xAxis: aData[index], yAxis: element,itemStyle: { color:'#FF9900' }
                                            })
                                        }
                                    }
                                    if(data.length>0){
                                        deviceOne.markPoint={
                                            data:data
                                        }
                                    }
                                }
                             
                                deviceOne.smooth=true;//光滑连接

                                if(item.limit!=null){
                                    var obj={
                                        data: [{yAxis: item.limit}]
                                    }   
                                    deviceOne.markLine=obj;  
                                }
                                seriesData.push(deviceOne);
                            });
                        }
                        this.drawLineChart(aData,seriesData);   
                    }else{
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }
				});
            },
            //获取设备列表
			getDevices() {
                 if(this.filters.projectId.toString()==""){
                    return;
                }
                this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString()
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    this.devices = res.data.data;
                    for (let index = 0; index < this.devices.length; index++) {
                        const element = this.devices[index];
                        this.deviceMap.set(element.mnCode,element.name);
                        
                    }
                    this.filters.mn=[];
				});
            },
            getFunctionalAreaList(){
				getFunctionalAreaList({}).then((res) => {
                    this.functionalAreaList=res.data.data;
                    res.data.data.forEach(element => {
						this.functionalAreaMap.set(element.id,element);
					});
				});
			},
            //获取选中设备可监测的因子
            getFactorsByMn(){
                // this.getDeviceName();
                if(this.filters.mn.toString()==""){
                    return;
                }
                if(in_array('-2',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                if(in_array('-1',this.filters.mn)){
                    this.filters.mn=[];
                    this.devices.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
                document.getElementById("chartLine").style.height=this.formHeight+"px";
			},
			setTime(){
                var end = new Date();
				var start = new Date();
				this.dataType="hour";
                start.setMinutes(0);
                start.setSeconds(0);
				start.setTime(start.setHours(start.getHours()-24));

                end.setMinutes(0);
                end.setSeconds(0);
                end.setTime(end.setHours(end.getHours()-1));

				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
                this.getFunctionalAreaList();
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)
            this.setTime();
            this.type=sessionStorage.getItem("type");

            window.onresize = function(){
                if(_this.chartLine!=null){
                    _this.chartLine.resize();
                }
            }
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    .dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
    .tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>



// WEBPACK FOOTER //
// TimeDistributionChart.vue?7fd41e0b